import md5 from 'md5';
import { types } from '../const/types.task';
import { FindConditioned, HideOld, RunRules } from '../functions/forms';

import { get, put, post } from '../api/_basic';

function formatDate(d) {
    function pad(s) {
        return s < 10 ? '0' + s : s;
    }
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
}

class ProcessApi {
    static async getInstancesOpened(lastWeek, from, to, ended, local) {
        try {
            const body = {};
            if (lastWeek) {
                let today = new Date();
                today.setDate(today.getDate() - 7);
                body.fechainicio = formatDate(today);
            } else {
                if (from) body.fechainicio = from;
                if (to) body.fechafin = to;
            }
            if (local) body.idlocal = local;
            if (ended) body.vencidos = ended;

            const response = await post(process.env.REACT_APP_API_INSTANCE_OPENED, body)
                .then((info) => {
                    if (info.result !== 'success') {
                        console.error(info.messages);
                        const error = { type: info.result, message: info.messages.join('<br/>') };
                        throw error;
                    }
                    return info;
                })
                .catch((err) => {
                    throw err;
                });

            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    static async get(lastWeek, from, to, ended, local) {
        try {
            const body = {};
            if (lastWeek) {
                let today = new Date();
                today.setDate(today.getDate() - 7);
                body.fechainicio = formatDate(today);
            } else {
                if (from) body.fechainicio = from;
                if (to) body.fechafin = to;
            }
            if (local) body.idlocal = local;
            if (ended) body.vencidos = ended;

            const response = await post(process.env.REACT_APP_API_PROCESS, body);
            console.log(response);
            return await ProcessApi.processFamilies(response);
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    static async processFamilies(data) {
        try {
            if (!data) return undefined;
            const processes = data;
            const families = processes.reduce((arr, process) => {
                process.modificado = process.instancias
                    ? process.instancias.reduce(
                          (last, i) => (last = last > i.modificado ? last : i.modificado),
                          '',
                      )
                    : '';
                if (!arr[process.familia]) {
                    arr[process.familia] = {
                        id: md5(process.familia),
                        nombre: process.familia,
                        instanciasesperandopormi: process.instanciasesperandopormi,
                        instanciastotales: process.instanciastotales,
                        instanciasvencidas: process.instanciasvencidas,
                        instanciascerradas: process.instanciascerradas,
                        instanciasactivas: process.instanciasactivas,
                        modificado: process.modificado,
                        procesos: [].concat([process]),
                    };
                } else {
                    arr[process.familia].instanciasesperandopormi +=
                        process.instanciasesperandopormi;
                    arr[process.familia].instanciastotales += process.instanciastotales;
                    arr[process.familia].instanciasvencidas += process.instanciasvencidas;
                    arr[process.familia].instanciascerradas += process.instanciascerradas;
                    arr[process.familia].instanciasactivas += process.instanciasactivas;
                    arr[process.familia].modificado =
                        arr[process.familia].modificado > process.modificado
                            ? arr[process.familia].modificado
                            : process.modificado;
                    arr[process.familia].procesos.push(process);
                }
                return arr;
            }, {});
            return {
                process: Object.keys(families).map(function(i) {
                    return families[i];
                }),
                messages: undefined,
            };
        } catch (error) {
            throw error;
        }
    }

    static getType(type, style, catalog) {
        switch (type) {
            case types.boolean:
                if (style === 'SINONAC') return types.action;
                else if (style === 'SINOC') return types.action;
                else return types.boolean;
            case types.number:
            case types.real:
                return types.real;
            case types.textfixed:
                return types.textfixed;
            case types.text:
                if (style === 'DESPLEGABLE') {
                    return types.options;
                } else {
                    return types.text;
                }
            case types.options:
                if (style === 'SIMPLE') {
                    return types.multioption;
                } else {
                    return types.options;
                }
            case types.temp:
                if (style === 'AUTOMATICO') {
                    return types.auto;
                } else {
                    return types.temp;
                }
            case types.date:
                return types.date;
            case types.time:
                return types.time;
            case types.datetime:
                return types.datetime;
            case types.local:
                return types.local;
            case types.photo:
                return types.photo;
            case types.section:
                return types.section;
            case types.tab:
                return types.tab;
            case 'CADENA':
                return types.text;
            default:
                return type;
        }
    }

    static async getHistorial(id) {
        try {
            return await get(process.env.REACT_APP_API_INSTANCE + '/' + id + '/historial').catch(
                (err) => {
                    return { error: err };
                },
            );
        } catch (error) {
            return { error: error };
        }
    }

    static async getInstances(ids) {
        const result = await Promise.all(
            ids.map(async (id) => {
                const info = await ProcessApi.getInstance(id);
                return {
                    process: info.proceso,
                    id: info.id,
                    local: info.nlocal,
                    idlocal: info.idLocal,
                    created: info.creado,
                    modificado: info.modificado,
                    assigned: info.mio,
                    expired: info.vencido,
                    closed: info.finalizado,
                    score: info.puntosefectivos,
                    max: info.puntosposibles,
                    percentage:
                        info === undefined || isNaN(info.puntosefectivos / info.puntosposibles)
                            ? '-%'
                            : ((info.puntosefectivos / info.puntosposibles) * 100).toFixed(0) + '%',
                    status:
                        info.finalizado === 0
                            ? info.vencido === true
                                ? 'vencida'
                                : 'activa'
                            : 'finalizada',
                };
            }),
        );
        return result;
    }

    static async getInstance(id) {
        try {
            const json = await get(`${process.env.REACT_APP_API_INSTANCE}/${id}`)
                .then((info) => {
                    if (info.result !== 'success') {
                        console.error(info.messages);
                        const error = { type: info.result, message: info.messages.join('<br/>') };
                        throw error;
                    }
                    return info.data;
                })
                .catch((err) => {
                    throw err;
                });
            return await ProcessApi.processForm(id, json);
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async getFormInstance(id) {
        try {
            return await get(`${process.env.REACT_APP_API_INSTANCEINFO}/${id}`).then((info) => {
                return ProcessApi.processInstanceInfo(id, info);
            });
        } catch (error) {
            throw error;
        }
    }

    static calculoPendiente(arr) {
        return arr.reduce((result, i) => {
            if (i.hijos && i.hijos.length > 0) {
                result = result || (i.pendiente && !i.desactivado);
            } else if (
                i.tipo === 'SINO' &&
                (i.estilo === 'SINONAC' || i.estilo === 'SINOC') &&
                i.obligatorio &&
                !i.desactivado
            ) {
                result =
                    result ||
                    (i.valor === undefined ||
                    (i.valor === false && (!i.comentario || i.comentario.length < 4))
                        ? true
                        : false);
            } else if (
                i.valor !== undefined &&
                i.valor !== '' &&
                i.valor !== null &&
                i.valor.toString().length > 0 &&
                i.valor.toString() !== '[]'
            ) {
                result = result || false;
            } else if (i.tipo === 'PESTANA' || i.tipo === 'SECCION') {
                result = result || false;
            } else {
                result = result || (i.obligatorio && !i.desactivado);
            }
            return result;
        }, false);
    }

    static async processInstanceInfo(id, form) {
        let tabs = undefined;
        if (form.estados) {
            const aux = Object.keys(form.estados).map(function(i) {
                return form.estados[i].map((tab) => {
                    tab.status = i;
                    tab.type = ProcessApi.getType(tab.tipo, tab.estilo, tab.catalogo);
                    tab.puntuacion = parseInt(tab.puntuacion, 10);
                    tab.puntuacionefectiva = parseInt(tab.puntuacionefectiva, 10);
                    tab.puntuacionposible = parseInt(tab.puntuacionposible, 10);
                    tab.obligatorio = true;

                    tab.hijos = tab.hijos.map((item) => {
                        return ProcessApi.getElement(item, tab, tab.desactivable);
                    });

                    tab.pendiente = ProcessApi.calculoPendiente(tab.hijos);

                    return tab;
                });
            });

            tabs = aux.reduce((arr, type) => {
                arr.push.apply(arr, type);
                return arr;
            }, []);
        }

        form.id = id;
        form.condicionados = FindConditioned(form.reglas);

        tabs = HideOld(form.condicionados, tabs, true);
        tabs = RunRules(form.reglas, tabs);

        form.tabs = tabs;

        if (form.instancia) {
            form.instancia.status =
                form.instancia.finalizado === 0
                    ? form.instancia.vencido === true
                        ? 'vencida'
                        : 'activa'
                    : 'finalizada';
            form.instancia.pendiente = tabs.reduce((result, t) => {
                result = result || t.pendiente;
                return result;
            }, false);
        }
        console.log(form);
        return form;
    }

    static getElement(item, tab, desactivable) {
        item.tab = tab.codigo;
        item.type = ProcessApi.getType(item.tipo, item.estilo, item.catalogo);
        item.disabled = item.sololectura === 1;
        item.puntuacion = parseInt(item.puntuacion, 10);
        item.puntuacionefectiva = parseInt(item.puntuacionefectiva, 10);
        item.puntuacionposible = parseInt(item.puntuacionposible, 10);
        item.desactivable = desactivable ? true : item.desactivable;
        item.hijos =
            item.hijos === undefined
                ? undefined
                : item.hijos.map((element) => {
                      return ProcessApi.getElement(element, tab, item.desactivable);
                  });
        if (item.hijos && item.hijos.length > 0) {
            item.obligatorio = !!item.obligatorio;
            item.pendiente = ProcessApi.calculoPendiente(item.hijos);
        }
        return item;
    }

    static async updateFields(id, changes, local, employee) {
        try {
            const arr = [{ codigo: 'LOCAL', valor: local }].concat(changes);
            if (employee) {
                arr.push({ codigo: 'TRABAJADOR', valor: employee });
            }
            return await put(process.env.REACT_APP_API_INSTANCE + '/' + id, { campos: arr });
        } catch (error) {
            throw error;
        }
    }

    static async executeTransition(id, changes, code, local, employee) {
        try {
            const arr = [{ codigo: 'LOCAL', valor: local }].concat(changes);
            if (employee) {
                arr.push({ codigo: 'TRABAJADOR', valor: employee });
            }
            const body = {
                transicion: code,
                campos: arr,
            };

            return await put(process.env.REACT_APP_API_INSTANCE + '/' + id, body)
                .then((info) => {
                    if (info.result !== 'success') {
                        console.error(info.messages);
                        const error = { type: info.result, message: info.messages.join('<br/>') };
                        throw error;
                    }
                    return info;
                })
                .catch((err) => {
                    throw err;
                });
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    static async createFile(instance, field, name, type, size) {
        try {
            const body = {
                name: name,
                type: type,
                size: size,
            };
            console.log(instance, field, name, type, size);
            return await post(
                `${process.env.REACT_APP_API_FILE_INSTANCE}/${instance}/${field}`,
                body,
            );
        } catch (error) {
            throw error;
        }
    }

    static async uploadImage(instance, field, info) {
        try {
            const { name, type, size } = info;
            const code = await ProcessApi.createFile(instance, field, name, type, size);

            const miniatura = await fetch(`${process.env.REACT_APP_API_FILE}/${code}/miniatura`, {
                method: 'PUT',
                body: info.thumbnail,
                headers: {
                    Authorization: sessionStorage.token,
                    Accept: 'application/json',
                },
            });
            const miniaturajson = miniatura.json();
            if (miniaturajson.error !== undefined) {
                throw Error(miniaturajson.error);
            }

            const response = await fetch(`${process.env.REACT_APP_API_FILE}/${code}/datos`, {
                method: 'PUT',
                body: info.link,
                headers: {
                    Authorization: sessionStorage.token,
                    Accept: 'application/json',
                },
            });
            const json = response.json();
            if (json.result !== 'success') {
                console.error(json.messages);
                const error = { type: json.result, message: json.messages.join(' ') };
                throw error;
            } else {
                return `${code}`;
            }
        } catch (error) {
            throw error;
        }
    }

    static async uploadFile(instance, field, info) {
        try {
            const { name, type, size, link } = info;
            const code = await ProcessApi.createFile(instance, field, name, type, size);
            const json = await put(`${process.env.REACT_APP_API_FILE}/${code}/datos`, link);
            if (json.result !== 'success') {
                console.error(json.messages);
                const error = { type: json.result, message: json.messages.join(' ') };
                throw error;
            } else {
                return `${code}`;
            }
        } catch (error) {
            throw error;
        }
    }
}

export default ProcessApi;



// WEBPACK FOOTER //
// ./src/api/ProcessApi.js